import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const updateMyMonitoringSiteDefault = async (siteId: string, isDefault: boolean): Promise<boolean> =>
  axios.get(`/my-monitoring/sites/UpdateSiteDefault?siteId=${siteId}&isDefault=${isDefault}`).then((res) => res?.data?.data)

type Props = {
  siteId: string
  isDefault: boolean
}

export const useMyMonitoringUpdateSiteDefault = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['updateMyMonitoringSiteDefault'],
    mutationFn: ({ siteId, isDefault }: Props) => updateMyMonitoringSiteDefault(siteId, isDefault),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated site default.')
      }
    },
    onError: (error) => {
      // if (notify) {
      toastError(error?.message || 'Failed to update site default.')
      // }
    },
    throwOnError: false
  })
